/* eslint-disable no-return-assign */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { GENERATE_OR_URI } from 'modules/CDL/individual/constant';
import { LCR_E2E_EOR_URL } from 'modules/civil-registry/constant';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import * as c from '../constant';

function ViewOR({ data, getReportAccess }) {
  const setModal = useContext(ModalContext);
  const authProfile = getJson('profile') || {};
  const [src, setSrc] = useState('');

  const bplsSrc = `${process.env.REACT_APP_WS}${c.BPLS_E2E_EOR_URL.replace(
    '{id}',
    _.get(data, 'id')
  )}`;

  const cedulaSrc = `${process.env.REACT_APP_WS}${GENERATE_OR_URI.replace(
    '{id}',
    _.get(data, 'id')
  )}`;

  const lcrSrc = `${process.env.REACT_APP_WS}${LCR_E2E_EOR_URL.replace(
    '{id}',
    _.get(data, 'id')
  )}`;

  const getSrc = () => {
    const permitType = _.get(
      data,
      'attributes.permit_type',
      '(No Module Type in Data)'
    );
    switch (permitType) {
      case 'Business Permit and License Application (BPLS)':
        return bplsSrc;
      case 'Community Tax Certificate CTC / CEDULA':
        return cedulaSrc;
      case 'Local Civil Registry':
        return lcrSrc;
      default:
        return '';
    }
  };

  useEffect(() => {
    const args = {
      path: getSrc(),
      email: _.get(authProfile, 'email'),
      output: 'I',
    };
    getReportAccess(args, (response) => {
      setSrc(response?.res?.res?.url || '');
    });
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  // sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                  // allow="fullscreen"
                  // loading="lazy"
                  // width="100%"
                  // height="600"
                  title="Official Receipt"
                  src={src}
                  // referrerPolicy="no-referrer"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewOR.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewOR);
